import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const TrendingNow = () => import('./views/Index.vue');

export default [
  {
    path: '/trending-now',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'TrendingNow',
        component: TrendingNow,
        meta: { title: i18n.global.t('settings.trendingNow') },
      },
    ],
  },
];
